import { FormPageInputItemFileUploadPiclib } from 'shared';

const convertPiclib = (fileSrn?: string): string | undefined => {
  if (fileSrn === '') {
    return undefined;
  }
  return fileSrn;
};

export const convertFileUploadPiclib = (
  value: FormPageInputItemFileUploadPiclib,
): string | undefined => {
  return convertPiclib(value.fileSrn);
};
